/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { CoreApiConfiguration } from '../core-api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { FeatureFlagResponse as ApiFeatureFlagResponse } from '../models/api/feature-flag-response';
import { ListBoardFeatureFlagsResponse as ApiListBoardFeatureFlagsResponse } from '../models/api/list-board-feature-flags-response';
import { ListFeatureFlagsResponse as ApiListFeatureFlagsResponse } from '../models/api/list-feature-flags-response';
import { createFeatureFlag } from '../fn/feature-flags/create-feature-flag';
import { CreateFeatureFlag$Params } from '../fn/feature-flags/create-feature-flag';
import { deleteFeatureFlag } from '../fn/feature-flags/delete-feature-flag';
import { DeleteFeatureFlag$Params } from '../fn/feature-flags/delete-feature-flag';
import { getFeatureFlag } from '../fn/feature-flags/get-feature-flag';
import { GetFeatureFlag$Params } from '../fn/feature-flags/get-feature-flag';
import { listBoardFeatureFlags } from '../fn/feature-flags/list-board-feature-flags';
import { ListBoardFeatureFlags$Params } from '../fn/feature-flags/list-board-feature-flags';
import { listFeatureFlags } from '../fn/feature-flags/list-feature-flags';
import { ListFeatureFlags$Params } from '../fn/feature-flags/list-feature-flags';
import { listTenantFeatureFlags } from '../fn/feature-flags/list-tenant-feature-flags';
import { ListTenantFeatureFlags$Params } from '../fn/feature-flags/list-tenant-feature-flags';
import { updateBoardFeatureFlags } from '../fn/feature-flags/update-board-feature-flags';
import { UpdateBoardFeatureFlags$Params } from '../fn/feature-flags/update-board-feature-flags';
import { updateFeatureFlag } from '../fn/feature-flags/update-feature-flag';
import { UpdateFeatureFlag$Params } from '../fn/feature-flags/update-feature-flag';
import { updateTenantFeatureFlags } from '../fn/feature-flags/update-tenant-feature-flags';
import { UpdateTenantFeatureFlags$Params } from '../fn/feature-flags/update-tenant-feature-flags';

@Injectable({ providedIn: 'root' })
export class FeatureFlagsService extends BaseService {
  constructor(config: CoreApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `listFeatureFlags()` */
  static readonly ListFeatureFlagsPath = '/v1/';

  /**
   * List FeatureFlags.
   *
   * List FeatureFlags of a board
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `listFeatureFlags()` instead.
   *
   * This method doesn't expect any request body.
   */
  listFeatureFlags$Response(
    params?: ListFeatureFlags$Params,
    context?: HttpContext
  ): Observable<StrictHttpResponse<ApiListFeatureFlagsResponse>> {
    return listFeatureFlags(this.http, this.rootUrl, params, context);
  }

  /**
   * List FeatureFlags.
   *
   * List FeatureFlags of a board
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `listFeatureFlags$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  listFeatureFlags(params?: ListFeatureFlags$Params, context?: HttpContext): Observable<ApiListFeatureFlagsResponse> {
    return this.listFeatureFlags$Response(params, context).pipe(
      map((r: StrictHttpResponse<ApiListFeatureFlagsResponse>): ApiListFeatureFlagsResponse => r.body)
    );
  }

  /** Path part for operation `createFeatureFlag()` */
  static readonly CreateFeatureFlagPath = '/v1/';

  /**
   * Create a FeatureFlag.
   *
   * Create a featureFlag
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `createFeatureFlag()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createFeatureFlag$Response(
    params: CreateFeatureFlag$Params,
    context?: HttpContext
  ): Observable<StrictHttpResponse<ApiFeatureFlagResponse>> {
    return createFeatureFlag(this.http, this.rootUrl, params, context);
  }

  /**
   * Create a FeatureFlag.
   *
   * Create a featureFlag
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `createFeatureFlag$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createFeatureFlag(params: CreateFeatureFlag$Params, context?: HttpContext): Observable<ApiFeatureFlagResponse> {
    return this.createFeatureFlag$Response(params, context).pipe(
      map((r: StrictHttpResponse<ApiFeatureFlagResponse>): ApiFeatureFlagResponse => r.body)
    );
  }

  /** Path part for operation `listBoardFeatureFlags()` */
  static readonly ListBoardFeatureFlagsPath = '/v1/boards/{boardId}';

  /**
   * List FeatureFlags for a board.
   *
   * List FeatureFlags for a board
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `listBoardFeatureFlags()` instead.
   *
   * This method doesn't expect any request body.
   */
  listBoardFeatureFlags$Response(
    params: ListBoardFeatureFlags$Params,
    context?: HttpContext
  ): Observable<StrictHttpResponse<ApiListBoardFeatureFlagsResponse>> {
    return listBoardFeatureFlags(this.http, this.rootUrl, params, context);
  }

  /**
   * List FeatureFlags for a board.
   *
   * List FeatureFlags for a board
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `listBoardFeatureFlags$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  listBoardFeatureFlags(
    params: ListBoardFeatureFlags$Params,
    context?: HttpContext
  ): Observable<ApiListBoardFeatureFlagsResponse> {
    return this.listBoardFeatureFlags$Response(params, context).pipe(
      map((r: StrictHttpResponse<ApiListBoardFeatureFlagsResponse>): ApiListBoardFeatureFlagsResponse => r.body)
    );
  }

  /** Path part for operation `updateBoardFeatureFlags()` */
  static readonly UpdateBoardFeatureFlagsPath = '/v1/boards/{boardId}';

  /**
   * Update FeatureFlags for a board.
   *
   * Update FeatureFlags for a board
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateBoardFeatureFlags()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateBoardFeatureFlags$Response(
    params: UpdateBoardFeatureFlags$Params,
    context?: HttpContext
  ): Observable<StrictHttpResponse<string>> {
    return updateBoardFeatureFlags(this.http, this.rootUrl, params, context);
  }

  /**
   * Update FeatureFlags for a board.
   *
   * Update FeatureFlags for a board
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `updateBoardFeatureFlags$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateBoardFeatureFlags(params: UpdateBoardFeatureFlags$Params, context?: HttpContext): Observable<string> {
    return this.updateBoardFeatureFlags$Response(params, context).pipe(
      map((r: StrictHttpResponse<string>): string => r.body)
    );
  }

  /** Path part for operation `listTenantFeatureFlags()` */
  static readonly ListTenantFeatureFlagsPath = '/v1/tenants/{tenantId}';

  /**
   * List FeatureFlags for a tenant.
   *
   * List FeatureFlags for a tenant
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `listTenantFeatureFlags()` instead.
   *
   * This method doesn't expect any request body.
   */
  listTenantFeatureFlags$Response(
    params: ListTenantFeatureFlags$Params,
    context?: HttpContext
  ): Observable<StrictHttpResponse<ApiListFeatureFlagsResponse>> {
    return listTenantFeatureFlags(this.http, this.rootUrl, params, context);
  }

  /**
   * List FeatureFlags for a tenant.
   *
   * List FeatureFlags for a tenant
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `listTenantFeatureFlags$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  listTenantFeatureFlags(
    params: ListTenantFeatureFlags$Params,
    context?: HttpContext
  ): Observable<ApiListFeatureFlagsResponse> {
    return this.listTenantFeatureFlags$Response(params, context).pipe(
      map((r: StrictHttpResponse<ApiListFeatureFlagsResponse>): ApiListFeatureFlagsResponse => r.body)
    );
  }

  /** Path part for operation `updateTenantFeatureFlags()` */
  static readonly UpdateTenantFeatureFlagsPath = '/v1/tenants/{tenantId}';

  /**
   * Update FeatureFlags for a tenant.
   *
   * Update FeatureFlags for a tenant
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateTenantFeatureFlags()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateTenantFeatureFlags$Response(
    params: UpdateTenantFeatureFlags$Params,
    context?: HttpContext
  ): Observable<StrictHttpResponse<string>> {
    return updateTenantFeatureFlags(this.http, this.rootUrl, params, context);
  }

  /**
   * Update FeatureFlags for a tenant.
   *
   * Update FeatureFlags for a tenant
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `updateTenantFeatureFlags$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateTenantFeatureFlags(params: UpdateTenantFeatureFlags$Params, context?: HttpContext): Observable<string> {
    return this.updateTenantFeatureFlags$Response(params, context).pipe(
      map((r: StrictHttpResponse<string>): string => r.body)
    );
  }

  /** Path part for operation `getFeatureFlag()` */
  static readonly GetFeatureFlagPath = '/v1/{id}';

  /**
   * Get a FeatureFlag.
   *
   * Get a featureFlag
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getFeatureFlag()` instead.
   *
   * This method doesn't expect any request body.
   */
  getFeatureFlag$Response(
    params: GetFeatureFlag$Params,
    context?: HttpContext
  ): Observable<StrictHttpResponse<ApiFeatureFlagResponse>> {
    return getFeatureFlag(this.http, this.rootUrl, params, context);
  }

  /**
   * Get a FeatureFlag.
   *
   * Get a featureFlag
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getFeatureFlag$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getFeatureFlag(params: GetFeatureFlag$Params, context?: HttpContext): Observable<ApiFeatureFlagResponse> {
    return this.getFeatureFlag$Response(params, context).pipe(
      map((r: StrictHttpResponse<ApiFeatureFlagResponse>): ApiFeatureFlagResponse => r.body)
    );
  }

  /** Path part for operation `deleteFeatureFlag()` */
  static readonly DeleteFeatureFlagPath = '/v1/{id}';

  /**
   * Delete a FeatureFlag.
   *
   * Delete a featureFlag
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deleteFeatureFlag()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteFeatureFlag$Response(
    params: DeleteFeatureFlag$Params,
    context?: HttpContext
  ): Observable<StrictHttpResponse<string>> {
    return deleteFeatureFlag(this.http, this.rootUrl, params, context);
  }

  /**
   * Delete a FeatureFlag.
   *
   * Delete a featureFlag
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `deleteFeatureFlag$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteFeatureFlag(params: DeleteFeatureFlag$Params, context?: HttpContext): Observable<string> {
    return this.deleteFeatureFlag$Response(params, context).pipe(
      map((r: StrictHttpResponse<string>): string => r.body)
    );
  }

  /** Path part for operation `updateFeatureFlag()` */
  static readonly UpdateFeatureFlagPath = '/v1/{id}';

  /**
   * Update a FeatureFlag.
   *
   * Update a featureFlag
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateFeatureFlag()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateFeatureFlag$Response(
    params: UpdateFeatureFlag$Params,
    context?: HttpContext
  ): Observable<StrictHttpResponse<string>> {
    return updateFeatureFlag(this.http, this.rootUrl, params, context);
  }

  /**
   * Update a FeatureFlag.
   *
   * Update a featureFlag
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `updateFeatureFlag$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateFeatureFlag(params: UpdateFeatureFlag$Params, context?: HttpContext): Observable<string> {
    return this.updateFeatureFlag$Response(params, context).pipe(
      map((r: StrictHttpResponse<string>): string => r.body)
    );
  }
}
